"use client";

const Loading = () => null;

export default Loading;
